import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CardWidgetTextInputWithErrors from "../../card-widget/error-card-widgets/CardWidgetTextInputWithErrors";

class ValidateableTextInputField extends Component {
  constructor(props) {
    super(props);
    this.validateValue({target: {value: ''}});
  }

  validateValue = (e) => {
    this.errorMessage = this.props.validationFunction(e.target.value);
    this.props.onChange(e, this.errorMessage);
  };

  onChange = (e) => {
    this.validateValue(e);
  };

  render() {
    this.errorMessage = this.props.customError ? this.props.customError : this.errorMessage;
    if (this.props.showErrors) {
      return (
          <CardWidgetTextInputWithErrors
              fieldLabel={this.props.fieldLabel}
              onChange={this.onChange}
              errorMessage={this.errorMessage}
              maxLength={this.props.maxLength}
          />
      );
    } else {
      return (
          <CardWidgetTextInputWithErrors
              fieldLabel={this.props.fieldLabel}
              onChange={this.onChange}
              errorMessage=''
              maxLength={this.props.maxLength}
          />
      );
    }
  }
}

ValidateableTextInputField.propTypes = {
  validationFunction: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool,
  customError: PropTypes.string,
  maxLength: PropTypes.string
};

export default ValidateableTextInputField;

